module.exports = __webpack_public_path__ + "static/media/microsoft-finance.40be31e9.svg";